var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0BC6FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,47.2c-12.2,0-22.2-10-22.2-22.2S12.8,2.8,25,2.8s22.2,10,22.2,22.2c0,2.1-0.3,4.2-0.9,6.3l-0.7-0.2 c0.6-2,0.9-4,0.9-6.1c0-11.9-9.6-21.5-21.5-21.5C13.1,3.5,3.5,13.1,3.5,25S13.1,46.5,25,46.5V47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,50C11.2,50,0,38.8,0,25c0-2.4,0.3-4.8,1-7.1l0.7,0.2c-0.7,2.2-1,4.5-1,6.9c0,13.4,10.9,24.3,24.3,24.3 S49.3,38.4,49.3,25S38.4,0.7,25,0.7V0c13.8,0,25,11.2,25,25S38.8,50,25,50z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.9,18.7l-9-3.4c-0.2-0.1-0.5,0-0.5,0.2c-0.1,0.2,0,0.5,0.2,0.5l7.9,3l-5.5,2.1L25.2,18 c-0.2-0.1-0.5,0-0.6,0.2c-0.1,0.2,0,0.5,0.2,0.6l6.1,2.8l-6,2.3l-12.6-4.8L25,14.3l3.1,1.2c0.2,0.1,0.5,0,0.5-0.2 c0.1-0.2,0-0.5-0.2-0.5l-3.2-1.2c-0.1,0-0.2,0-0.3,0l-13.8,5.2c-0.2,0.1-0.3,0.2-0.3,0.4V21c0,0.2,0.1,0.3,0.3,0.4l4.3,1.6v1.5 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-1.1l8.6,3.3c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l6.5-2.5v6.7c-2,1.1-4.3,1.6-6.6,1.6 c-3.2,0-6.3-1.1-8.8-3v-3.3c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v3.5c0,0.1,0.1,0.2,0.2,0.3c2.7,2.1,6,3.3,9.5,3.3 c2.3,0,4.6-0.5,6.6-1.5v1.7c-0.7,0.2-1.2,0.8-1.2,1.5c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0-0.7-0.5-1.4-1.2-1.5v-2.1 c0.7-0.4,1.3-0.8,2-1.3c0.1-0.1,0.2-0.2,0.2-0.3V23l4.3-1.6c0.2-0.1,0.3-0.2,0.3-0.4v-1.9C39.2,18.9,39.1,18.7,38.9,18.7L38.9,18.7z  M32.8,35c0,0.4-0.3,0.8-0.8,0.8c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8C32.5,34.2,32.8,34.6,32.8,35L32.8,35z M11.7,19.7 l12.9,4.9v1l-12.9-4.9V19.7z M25.4,25.6v-1l6.2-2.4v1L25.4,25.6z M33.8,29.4c-0.4,0.3-0.8,0.6-1.3,0.9v-6.5l1.3-0.5V29.4z  M32.5,22.9v-1l5.8-2.2v1L32.5,22.9z M32.5,22.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentteam);
export default __webpack_public_path__ + "static/media/studentteam.72b51b7ed5d2315e03428ea706a822d2.svg";
export { ForwardRef as ReactComponent };